import {useSelector} from 'react-redux'
import {IState} from '../../interfaces/IState'

export function useAuthorized():boolean{
    const token = useSelector((state:IState)=>state.token)
    return !!token
}